import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#86868B", fillRule: "evenodd", d: "M6.558 9.558a.625.625 0 0 1 .884 0L12 14.116l4.558-4.558a.625.625 0 1 1 .884.884l-5 5a.625.625 0 0 1-.884 0l-5-5a.625.625 0 0 1 0-.884Z", clipRule: "evenodd" }));
export {
  t as default
};
